export const Roles = {
  ADMIN: 1,
  MANAGER: 2
} as const;

export type RoleType = typeof Roles[keyof typeof Roles];